import { Sidebar } from '@trukt/ui/Sidebar';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useMsal, useAccount } from '@azure/msal-react';
import AcertusLogo from './assets/acertus-logo.png';

import packageJson from '../../../../../package.json';

import { useSidebarItems } from './hooks';

export const SidebarContainer = () => {
  const sidebarItems = useSidebarItems();
  const msal = useMsal();
  const account = useAccount(msal.accounts[0]);

  return (
    <div>
      {/* @ts-expect-error */}
      <InfiniteScroll
        hasChildren={false}
        dataLength={sidebarItems.reportItems.length}
        hasMore={Boolean(sidebarItems.reportsQuery.hasNextPage)}
        loader={null}
        scrollableTarget="sidebar-scroll-container"
        style={{ display: 'none' }}
        next={sidebarItems.reportsQuery.fetchNextPage}
      />

      <Sidebar
        items={sidebarItems.items}
        accountInfo={account}
        version={packageJson.version}
        onLogoutClick={() => msal.instance.logoutRedirect({ account })}
        logo={AcertusLogo}
      />
    </div>
  );
};
